export default {
  'mySupportManagement.addMySupport': 'Add My Support',
  'mySupportManagement.icon': 'Icon',
  'mySupportManagement.title': 'Title',
  'mySupportManagement.url': 'Link',
  'mySupportManagement.comments': 'Comments',
  'mySupportManagement.uploadTips': 'Usually choose to upload square images;',
  'mySupportManagement.uploadImgTips': 'File format must be .jpg .jpeg .png;Size is less than 128K.',
  'mySupportManagement.uploadImgTypeError': 'You can only upload jpg/jpeg/png/JPG/JPEG/PNG file!',
  'mySupportManagement.uploadImgSizeError': 'Image must smaller than 128KB!',
}
